<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :fixed-header="true"
    :disable-pagination="true"
    :loading="$apollo.loading"
    :height="tableHeight"
    :search="search"
    :sort-by="sortBy"
    loading-text="Laddar... var god vänta!"
    no-data-text="Ingen data..."
    no-results-text="Inget resultat på din sökning..."
    hide-default-footer
    @click:row="onClickRow"
  >
    <template v-slot:top>
      <v-dialog v-model="showEditModal" width="800">
        <MasterdataEmailTemplatesEdit
          v-if="showEditModal"
          :uuid="edit_uuid"
          @close="
            showEditModal = false
            edit_uuid = null
          "
        />
      </v-dialog>
      <v-toolbar flat>
        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Sök..."
          single-line
          hide-details
          rounded
          filled
          dense
        ></v-text-field>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer />
        <v-btn @click="exportExcel" rounded class="mr-4">
          Exportera till Excel
          <v-icon small right>mdi-file-export-outline</v-icon>
        </v-btn>
        <v-dialog v-model="showCreateModal" width="800" persistent>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on" rounded>
              Lägg till
            </v-btn>
          </template>
          <MasterdataEmailTemplatesCreate
            @close="showCreateModal = false"
            v-if="showCreateModal"
          />
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.action="{ item }">
      <v-menu offset-y v-model="item.showMenu">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            @click="
              showEditModal = true
              edit_uuid = item.uuid
            "
            @mouseup="item.showMenu = false"
          >
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Redigera</v-list-item-title>
          </v-list-item>
          <v-dialog v-model="showDeleteModal" width="500">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on" @mouseup="item.showMenu = false">
                <v-list-item-icon>
                  <v-icon>mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Ta bort</v-list-item-title>
              </v-list-item>
            </template>
            <MasterdataEmailTemplatesDelete
              :uuid="item.uuid"
              @close="showDeleteModal = false"
              v-if="showDeleteModal"
            />
          </v-dialog>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>

<script>
import MasterdataEmailTemplatesCreate from './MasterdataEmailTemplatesCreate'
import MasterdataEmailTemplatesDelete from './MasterdataEmailTemplatesDelete'
import MasterdataEmailTemplatesEdit from './MasterdataEmailTemplatesEdit'
import GET_MAIL_TEMPLATES from '@/gql/mailTemplates/queries/GetMailTemplates.gql'
import { tableHeight } from '@/mixins/tableHeight'
import { format } from 'date-fns'
import { exportExcel } from '@/services/export-excel-service.js'
import { get } from 'vuex-pathify'

export default {
  name: 'MasterdataEmailTemplates',

  components: {
    MasterdataEmailTemplatesCreate,
    MasterdataEmailTemplatesDelete,
    MasterdataEmailTemplatesEdit,
  },

  mixins: [tableHeight()],

  data() {
    return {
      edit_uuid: null,
      showEditModal: false,
      showDeleteModal: false,
      showCreateModal: false,
      formTitle: 'Email mallar',
      headers: [
        { text: 'Mallnamn', value: 'name' },
        { text: 'Uppdaterad av', value: 'updated_by.email' },
        { text: 'Uppdaterad', value: 'updated' },
        { text: 'Skapad av', value: 'created_by.email' },
        { text: 'Skapad', value: 'created' },
        { text: '', value: 'action', align: 'right' },
      ],
      search: '',
      sortBy: 'uuid',
    }
  },

  apollo: {
    mailTemplates: {
      query: GET_MAIL_TEMPLATES,
      manual: true,
      result({ data }) {
        this.$store.set(
          'mailTemplates/data',
          ((data && data.mailTemplates) || []).reduce((a, b) => {
            a[b.uuid] = b
            return a
          }, {}),
        )
      },
    },
  },

  computed: {
    mailTemplates: get('mailTemplates/data'),
    items() {
      return Object.values(this.mailTemplates || {}).map(x => ({
        ...x,
        created: format(new Date(x.created), 'yyyy-MM-dd HH:mm'),
        updated: format(new Date(x.updated), 'yyyy-MM-dd HH:mm'),
      }))
    },
  },

  methods: {
    onClickRow(item) {
      this.edit_uuid = item.uuid
      this.showEditModal = true
    },

    exportExcel() {
      const filename = `Email mallar`

      const workbook = {
        name: filename,
        sheets: [
          {
            name: 'data',
            data: this.items.map(row => {
              return {
                Mallnamn: row.name,
                'Uppdaterad av': row.updated_by,
                Uppdaterad: row.updated,
                'Skapad av': row.created_by,
                Skapad: row.created,
              }
            }),
          },
        ],
      }

      exportExcel(filename, workbook)
    },
  },
}
</script>
